import React from "react";

import cx from "classnames";

import { Heading } from "../Heading";

import styles from "./PageHeader.scss";

/**
 * Props for the PageHeader component.
 */
interface PageHeaderProps {
  /**
   * Page title to display
   */
  header?: string;
  /**
   * Function to render action to right of title (like a button component)
   */
  renderRightContent?: () => React.ReactNode;
  /**
   * Flag to determine if there should be a bottom border and margin
   * Defaults to true
   */
  withBottomBorder?: boolean;
  /**
   * Flag to determine if the header should have a margin
   * Defaults to false
   */
  removeMarginBottom?: boolean;
}

/**
 * Page Header component that provides all of the proper styles for the single page header.
 * There is a providing utility function prop for adding content to the right side of the header.
 *
 * @category Layout
 * @component PageHeader
 */

function PageHeader({
  header,
  renderRightContent = () => null,
  withBottomBorder = true,
  removeMarginBottom = false,
}: PageHeaderProps) {
  const rightContent = renderRightContent();

  const classNames = cx(styles["page-header"], {
    [styles["page-header--with-bottom-border"]]: withBottomBorder,
    [styles["page-header--remove-margin-bottom"]]: removeMarginBottom,
  });

  return (
    <div className={classNames}>
      <Heading level="1">{header}</Heading>
      {rightContent}
    </div>
  );
}

export default PageHeader;
